// stores/kanban.store.ts
import { defineStore } from 'pinia'
import { useKanbans } from '@src/composables/useKanbans'

export const useKanbanStore = defineStore('kanban', () => {
    const {
        kanbans,
        loading,
        loadKanbans
    } = useKanbans()

    return {
        kanbans,
        loading,
        loadKanbans
    }
})
